import React from 'react';

const HeroSection = ({ section }) => {
  const sectionData = section.section_data || {};
  const hasOverlay = sectionData.overlay_enabled;
  const alignment = sectionData.alignment || 'center';

  return (
    <section
      className="hero-section"
      style={{
        backgroundImage: section.image ? `url(${section.image})` : 'none',
        backgroundColor: section.background_color || '#f8f9fa',
        color: section.text_color || '#000000',
        minHeight: '400px',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: alignment === 'center' ? 'center' : alignment === 'left' ? 'flex-start' : 'flex-end',
        padding: '80px 20px',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        textAlign: alignment
      }}
    >
      {hasOverlay && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: sectionData.overlay_color || 'rgba(0,0,0,0.5)',
            zIndex: 1
          }}
        />
      )}
      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          {section.title && (
            <h1 style={{ fontSize: '3rem', fontWeight: 'bold', marginBottom: '1rem' }}>
              {section.title}
            </h1>
          )}
          {section.subtitle && (
            <h2 style={{ fontSize: '1.75rem', fontWeight: 'normal', marginBottom: '1.5rem', opacity: 0.9 }}>
              {section.subtitle}
            </h2>
          )}
          {section.content && (
            <div
              style={{ marginBottom: '2rem', fontSize: '1.2rem', lineHeight: '1.6' }}
              dangerouslySetInnerHTML={{ __html: section.content }}
            />
          )}
          {section.button_text && section.button_link && (
            <a
              href={section.button_link}
              className="btn btn-primary btn-lg"
              style={{ marginTop: '1rem' }}
            >
              {section.button_text}
            </a>
          )}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
